import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect, dispatch } from "./recontext/store";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import ListTeams from "./components/ListTeams";
import ProfileDialog from "./components/ProfileDialog";
import TeamDialog from "./components/TeamDialog";
import LoginDialog from "./components/LoginDialog";
import Notificaiton from "./components/Notification";
import Messenger from "./components/Messenger";
import Intro from "./components/Intro";
import { api } from "./services";

const styles = theme => ({
  container: {
    flexGrow: 1
  }
});

class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ready: true
    };
  }

  componentDidMount() {
    this.getCurrentUser();
  }

  async getCurrentUser() {
    // fetch from local
    const userDataString = localStorage.getItem("USER_DATA");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        if (!userData || !userData.id) localStorage.clear();
        else dispatch("SET_USER", { user: userData });
      } catch (error) {
        localStorage.clear();
      }
    }

    await api.getMe();

    this.setState({
      ready: true
    });
  }

  render() {
    const { classes } = this.props;
    const { ready } = this.state;

    if (!ready) return <Loading visible />;

    return (
      <div className={classes.container}>
        <Header />
        <Intro />
        <ListTeams />
        <Messenger />
        <Footer />
        <ProfileDialog />
        <TeamDialog />
        <LoginDialog />
        <Notificaiton />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(App));
